var map = {
	"./2-1.jpg": 119991,
	"./2-1.webp": 953103,
	"./2-2.jpg": 521057,
	"./2-2.webp": 446866,
	"./2-3.jpg": 386940,
	"./2-3.webp": 39746,
	"./2-4.jpg": 814950,
	"./2-4.webp": 555592,
	"./3-1.jpg": 800589,
	"./3-1.webp": 523891,
	"./3-2.jpg": 646000,
	"./3-2.webp": 932371,
	"./3-3.jpg": 958999,
	"./3-3.webp": 498197,
	"./banner1.jpg": 278646,
	"./banner1.webp": 488779,
	"./banner2.jpg": 759130,
	"./banner2.webp": 753931,
	"./banner3.jpg": 498761,
	"./banner3.webp": 42398
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 316805;